import React from "react";
import { Box } from "@mui/material";
import Typography from "@mui/material/Typography";

const BlogContent = ({ content }) => (
  <Box>
    <div dangerouslySetInnerHTML={{ __html: content }} />
  </Box>
);

export default BlogContent;
